export default __webpack_public_path__ + "static/media/ic-format-bold.fd23f67c.svg";